module.exports = __webpack_public_path__ + "img/10Rounds.d2485514.jpg";